import { render, staticRenderFns } from "./WF11_Stylists.vue?vue&type=template&id=3023d3c9&scoped=true"
import script from "./WF11_Stylists.vue?vue&type=script&lang=js"
export * from "./WF11_Stylists.vue?vue&type=script&lang=js"
import style0 from "./WF11_Stylists.vue?vue&type=style&index=0&id=3023d3c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3023d3c9",
  null
  
)

export default component.exports